import React, {  Component } from "react";
import Carousal from "../../../../components/Carousal";

const clientReview = [
  {
    review: "Crediwatch offers an extremely powerful suite of tools, that can strengthen any financial services organisation and makes it a must have. Data is the new oil as many say, it is critical that organisations out there are able to leverage this to the best of their abilities and their business models.",
    name: "Utham Reddy",
    img: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/testimonial/utham-reddy.png`,
    designation: "Chief product officer, Credit Saison"
  },
  {
    review: "Near real-time monitoring of small businesses using alternative data and public data is a disruptive concept. Crediwatch could be an interesting proposition as it brings in multiple variables at one place.",
    name: "Yogendra Rustagi",
    img: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/testimonial/yogendra-rustagi.jpeg`,
    designation: "Section Head: Policy, Risk and Monitoring, Corporate and SME, Aditya Birla Finance Limited"
  },
  {
    review: "What I liked the most about Crediwatch solutions was the user-friendliness of their UI/UX. That goes a long way when you have limited time and resources at hand. It was definitely more intuitive and interactive than any other portals I ever used.",
    name: "Ranjit Yadwadkar",
    img: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/testimonial/ranjit-yadwadkar.jpeg`,
    designation: "Designated Partner, Baritone Capital Advisory LLP"
  }
]
class Review extends Component {
  render() {
    const settings = {
      slidesToShow: 1,
      infinite: true,
      speed:500
    };
    return (
      <div >
        <h2 className="businessTitle text-center ff-renner-bold">
          What clients think of Crediwatch
        </h2>
        <div className='d-flex align-items-center justify-content-center'>
          <div className='line text-primary bg-primary mt-4' />
        </div>
        <div>
          <Carousal settings={settings}>
            {clientReview.map(each =>
              <div className="mt-4 mb-4 pl-3 pr-3">
                <div className="card card-hover-shadow-5x">
                <div className="align-self-center text-center p-5">
                  <div className="avatar-icon-wrapper align-self-center mt-4">
                    <div className="img-icon avatar-icon">
                      <img src={each.img} alt="" />
                    </div>
                  </div>
                  <h6 className='review-title card-text mb-3 mt-3 ff-renner-book'>{each.review}</h6>
                  <h5 className='mb-2 font-weight-bolder mb-3 ff-renner-bold'>{each.name}</h5>
                  <h6 className='mb-4 font-weight-bold ff-renner-semi'>{each.designation}</h6>
                </div>
                </div>
              </div>
            )}
          </Carousal>
        </div>
      </div>
    );
  }
}
export default Review


